import { RefObject, useLayoutEffect, useState } from "react";

export interface ElementSize {
  widthPx: number;
  heightPx: number;
}

export const useElementSize = (ref: RefObject<HTMLElement | null>) => {
  const [size, setSize] = useState<ElementSize>({ widthPx: 0, heightPx: 0 });

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const measure = () =>
      setSize((previous) =>
        previous.widthPx === element.clientWidth &&
        previous.heightPx === element.clientHeight
          ? previous
          : { widthPx: element.clientWidth, heightPx: element.clientHeight }
      );

    const observer = new ResizeObserver(measure);
    observer.observe(element);
    measure();

    return () => observer.disconnect();
  }, [ref]);

  return size;
};
